var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9906 16H16M1 16H1.00937M4.74766 16H4.75703M8.49532 16H8.50468M12.243 16H12.2523M15.9906 1H16M1 1H1.00937M4.74766 1H4.75703M8.49532 1H8.50468M12.243 1V1.00938M1 5.6875C1 5.43886 1.09871 5.2004 1.27442 5.02459C1.45012 4.84877 1.68843 4.75 1.93691 4.75H15.0537C15.3022 4.75 15.5405 4.84877 15.7162 5.02459C15.8919 5.2004 15.9906 5.43886 15.9906 5.6875V11.3125C15.9906 11.5611 15.8919 11.7996 15.7162 11.9754C15.5405 12.1512 15.3022 12.25 15.0537 12.25H1.93691C1.68843 12.25 1.45012 12.1512 1.27442 11.9754C1.09871 11.7996 1 11.5611 1 11.3125V5.6875Z",
    stroke: "#38CB89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.c01c2b36f5d9634034260bf67b2e9743.svg";
export { ForwardRef as ReactComponent };